export default __webpack_public_path__ + "static/media/crai_logo_mb.cb24e4cd.svg";